import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Checkbox, FormControlLabel, Typography,
} from '@mui/material';
import { Field } from '../../UI';
import { tipoTelefonesTypes } from '../../../../types/tipoTelefonesTypes';

/**
 * Telefones do cliente (AW2-1136 Etapa 2) — porta de
 * `TelefoneDadosCliente.jsx` real, lista somente-leitura — sem "Adicionar
 * Telefone", sem ícone de excluir, sem ícone de copiar (produção real não
 * tem nenhum desses 3 aqui, diferente de `TelefoneDevedor.jsx`). "Tipo
 * Telefone" exibido via `tipoTelefonesTypes` (mapa estático real), não um
 * select reativo a selector — o campo nunca é editado nesta tela.
 */
export default function TelefoneCliente({ telefones }) {
  return (
    <>
      <Typography variant="h3" sx={{ mt: 3, mb: 1.5 }}>Telefones:</Typography>
      {telefones.map((telefone, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box
          key={index}
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(4, minmax(0, 1fr))' },
            gap: 'clamp(10px, 0.8vw, 22px)',
            alignItems: 'end',
            mb: 1.5,
          }}
        >
          <Field label="Tipo de Telefone:" value={tipoTelefonesTypes[telefone.tipoTelefone] ?? ''} disabled />
          <Field label="DDD:" value={telefone.ddd ?? ''} disabled />
          <Field label="Telefone:" value={telefone.numero ?? ''} disabled />
          <Field label="Observação:" value={telefone.observacao ?? ''} disabled />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FormControlLabel
              control={<Checkbox size="small" checked={Boolean(telefone.principal)} disabled />}
              label={<Typography variant="body2">Principal</Typography>}
              sx={{ ml: 0 }}
            />
            <FormControlLabel
              control={<Checkbox size="small" checked={Boolean(telefone.permitirWhatsApp)} disabled />}
              label={<Typography variant="body2">WhatsApp</Typography>}
              sx={{ ml: 0 }}
            />
          </Box>
        </Box>
      ))}
    </>
  );
}

TelefoneCliente.propTypes = {
  telefones: PropTypes.arrayOf(PropTypes.shape({
    idTelefone: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tipoTelefone: PropTypes.string,
    ddd: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    numero: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    observacao: PropTypes.string,
    principal: PropTypes.bool,
    permitirWhatsApp: PropTypes.bool,
  })),
};

TelefoneCliente.defaultProps = {
  telefones: [],
};
